<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Technician" title="Product Stock Logs" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-10">
										<div class="mm-cart-text">
											<table class="product_table">
												<thead style="font-size: medium;">
													<tr>
														<th>Technician Name</th>
														<th style="text-align: left;">:</th>
														<td style="text-align: left;">{{ technician.name }}</td>
													</tr>
													<tr>
														<th>Product</th>
														<th style="text-align: left;">:</th>
														<td style="text-align: left;">{{ technician.product_name }}</td>
													</tr>
													<tr>
														<th>Current Stock</th>
														<th style="text-align: left;">:</th>
														<td style="text-align: left;">{{ technician.current_stock }}</td>
													</tr> 
												</thead>
											</table>                                           
                                        </div>
									</div>
                                    <div class="col-md-2">
                                        <a href="#" @click.prevent="handleGoBack" class="btn btn-primary float-end"><i
                                                    class='bx bx-chevrons-left'></i> Back</a>
                                    </div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-8 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="technicianStockLogs()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>  
                                            <th>Type</th>
											<th>Stock</th>
											<th>Remaining Stock</th>
											<th>Updated By</th>
											<th>Updated On</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(stock_logs.length)">
                                        <tr align="center" v-for="(stock_log, index) in stock_logs" :key="index">
                                            <td>{{ (from - 1) + index + 1 }}</td>
                                            <td>
												<span class="badge rounded-pill bg-success" v-if="stock_log.status == 1">Added</span>
												<span class="badge rounded-pill bg-warning" v-else-if="stock_log.status == 2">Saled</span>
												<span class="badge rounded-pill bg-danger" v-else>Returned</span>
											</td>
											<td>{{ stock_log.quantity }}</td>
											<td>{{ stock_log.balance_stock }}</td>
											<td>{{ stock_log.added_user_name }}</td>
											<td>{{ stock_log.converted_created_at }}</td>
                                        </tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="6" class="text-center">No stock logs found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
									<a class="page-link" href="#" @click.prevent="technicianStockLogs(page.url)" tabindex="-1">
										<span v-if="index === 0">Prev</span>
										<span v-else-if="index === pagination.length - 1">Next</span>
										<span v-else v-html="page.label"></span>
									</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script setup>
import Swal from '@/utils/swal';
import { get } from '@/utils/api';
import { routes } from '@/constants/routes';
import { onMounted, ref, getCurrentInstance } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { goBack } from '@/utils/urlHider';

const router = useRouter();
const route = useRoute();
const { proxy } = getCurrentInstance();

const product_id = route.query.id;
const technician_id = route.query.tc_id;
const listing_length = ref(10);
const errors = ref({});
const technician = ref({});
const stock_logs = ref([]);
const from = ref(null);
const to = ref(null);
const total = ref(null);
const pagination = ref({});

const technicianStockLogs = (url = null) => {

	const params = {
		limit: listing_length.value,
		technician_id: technician_id,
		product_id: product_id
	}

	const requestUrl = url ?? routes.TechnicianStockLogs;

	get(requestUrl, { params }, false)
		.then((response) => {
			if (response.status === 200) {
				console.log(response.data.data);
                stock_logs.value = response.data.data.technician_logs.data;
                technician.value = response.data.data.technician;
				pagination.value = response.data.data.technician_logs.links;
				from.value = response.data.data.technician_logs.from;
				to.value = response.data.data.technician_logs.to;
				total.value = response.data.data.technician_logs.total;
            } else {
                Swal.fire('', response.data.message || 'Error fetching data', 'error');
            }
		})
		.catch((error) => {
			if (error.response?.status === 422) {
                Swal.fire('', error.response.data.message?.technician_id?.[0] || error.response.data.message?.limit?.[0] || error.response.data.message?.product_id?.[0] || 'Validation error', 'error');
            } else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

onMounted(() => {
	technicianStockLogs();
})

const handleGoBack = () => {
	const success = goBack(router);
	if (!success) {
		// If no history, go to dashboard as fallback
		router.push({ name: 'defaultRoot' });
	}
};
</script>